module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M8.43,17.05H29.72a1.39,1.39,0,0,0,0-2.78H8.43a1.39,1.39,0,0,0,0,2.78Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M28.24,23.4A1.38,1.38,0,0,0,26.85,22H5.56a1.39,1.39,0,0,0,0,2.77H26.85A1.39,1.39,0,0,0,28.24,23.4Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M54,24.38l-5.76-4.8a5.18,5.18,0,0,0-3.33-1.21H39.41v-.68a3.4,3.4,0,0,0-3.15-3.39v0H33.88a1.37,1.37,0,0,0,0,2.74H36a.67.67,0,0,1,.64.67v21.2h-8.2l-.18,0a5,5,0,0,0-.28-.8c0-.09-.08-.16-.12-.25a4.67,4.67,0,0,0-.27-.49,2.33,2.33,0,0,0-.17-.26c-.1-.14-.21-.28-.32-.41a2.5,2.5,0,0,0-.22-.24,3.33,3.33,0,0,0-.39-.36l-.23-.2c-.16-.12-.32-.22-.5-.33l-.19-.12a5.3,5.3,0,0,0-.77-.34l-.15,0a5.32,5.32,0,0,0-.57-.16h0a5.45,5.45,0,0,0-6.37,4H15.48a.69.69,0,0,1-.68-.68V28.83a1.37,1.37,0,0,0-2.73,0v9.38a3.41,3.41,0,0,0,3.41,3.41h2.24a5.48,5.48,0,0,0,1.79,2.82l.06.07h0l0,0a5.47,5.47,0,0,0,2.51,1.12,5.29,5.29,0,0,0,.9.08,5.8,5.8,0,0,0,1.82-.32A5.45,5.45,0,0,0,28,42.46a6.11,6.11,0,0,0,.3-.85H41a5.46,5.46,0,0,0,10.58,0h.88a3.41,3.41,0,0,0,3.4-3.41V28.38A5.14,5.14,0,0,0,54,24.38ZM23,43a2.94,2.94,0,0,1-.51-.05l-.15,0A1.73,1.73,0,0,1,22,42.8l-.16-.06a2.69,2.69,0,0,1-.29-.16l-.14-.09a2.74,2.74,0,0,1-1.16-2.21v-.05A2.74,2.74,0,0,1,23,37.52h0a2.63,2.63,0,0,1,.49,0l.2,0,.3.1.19.08.26.14.17.12.23.19.15.15.18.22a1.77,1.77,0,0,1,.12.17c.06.09.1.18.15.27l.09.18a3,3,0,0,1,.1.32c0,.06,0,.11,0,.17a2.24,2.24,0,0,1,.06.52h0A2.73,2.73,0,0,1,23,43Zm25.18-.8a2.68,2.68,0,0,1-1.93.8,2.72,2.72,0,0,1-2.73-2.72h0c0-.09,0-.17,0-.26a2.58,2.58,0,0,1,0-.29.29.29,0,0,0,0-.1,2.73,2.73,0,0,1,.39-.87,2.23,2.23,0,0,1,.19-.24c0-.05.09-.12.14-.17l.14-.11a2.71,2.71,0,0,1,1.24-.63,2.51,2.51,0,0,1,.55-.06h0A2.74,2.74,0,0,1,49,40.26,2.69,2.69,0,0,1,48.18,42.19Zm4.91-4a.67.67,0,0,1-.67.67h-.88a5.46,5.46,0,0,0-10.58,0H39.41V21.1h5.45a3,3,0,0,1,.43,0,2.75,2.75,0,0,1,.41.11,2.39,2.39,0,0,1,.74.43l5.76,4.8a2.48,2.48,0,0,1,.89,1.9Z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3d1b052"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/ExpeditedOneIcon.vue
// module id = 761
// module chunks = 0